import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { styles } from '../../../../styles/themes/style'

const HomeHighlightsMobileDesktopPrompt: FunctionComponent = () => (
    <Prompt>
        <PromptTitle>{'Available on your computer'}</PromptTitle>
        <PromptSubtitle>
            Open LeadDelta on a laptop or desktop with the Chrome extension to sync contacts and unlock this section.
        </PromptSubtitle>
    </Prompt>
)

const Prompt = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 24px 16px;
    text-align: center;
`

const PromptTitle = styled.p`
    margin: 0;
    font-family: NunitoSans, 'Nunito Sans', sans-serif;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    color: ${styles.colors.black600};
`

const PromptSubtitle = styled.p`
    margin: 0;
    font-family: NunitoSans, 'Nunito Sans', sans-serif;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    color: ${styles.colors.black400};
`

export default HomeHighlightsMobileDesktopPrompt
